const translations = {
  "en": {
    "Manage Subscription": "Manage Subscription"
  },
  "zh-tw": {
    "Manage Subscription": "管理訂閱"
  }
};

export default translations;
